import axios from 'axios'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootStateType } from 'store'
import { uploadpath, UploadpathType, UPLOAD_PATH_TYPE } from 'api/uploadpath'
import { fileupload } from 'api/fileupload'
import { parcelinfo, ParcelInfoType } from 'api/parcelinfo'
import { ErrorResponseType } from 'api/types'

export type DriverSendState = {
  status: 'idle' | 'loading' | 'failed' | 'success'
  error?: ErrorResponseType
}

const initialState: DriverSendState = {
  status: 'idle',
}

type Props = {
  sessionId: string
  type: UploadpathType
  parcelFile?: FileList
  slipFile?: FileList
  data: ParcelInfoType
}
type RejectConfig = {
  rejectValue: ErrorResponseType
}
export const driverSend = createAsyncThunk<void, Props, RejectConfig>(
  'driverSend/driverSend',
  async (props: Props, thunkAPI) => {
    const { sessionId, type, parcelFile, slipFile, data } = props
    try {
      const { parcelPath, slipPath } = await uploadpath(sessionId, type)

      if (parcelFile) {
        await fileupload(parcelPath, parcelFile)
      }
      if (type === UPLOAD_PATH_TYPE.BOTH && slipPath && slipFile) {
        await fileupload(slipPath, slipFile)
      }

      return await parcelinfo(sessionId, data)
    } catch (error) {
      if (axios.isAxiosError(error) && error?.response) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
      throw error
    }
  }
)

export const driverSendSlice = createSlice({
  name: 'driverSend',
  initialState,
  reducers: {
    clearStatus: state => {
      state.status = 'idle'
    },
  },
  extraReducers: builder => {
    builder
      .addCase(driverSend.pending, state => {
        state.status = 'loading'
      })
      .addCase(driverSend.fulfilled, state => {
        state.status = 'success'
      })
      .addCase(driverSend.rejected, (state, action) => {
        state.status = 'failed'
        if (action.payload) {
          state.error = action.payload
        }
      })
  },
})

export const { clearStatus } = driverSendSlice.actions

export const selectDriverSend = (state: RootStateType) => ({ ...state.driverSend })

export default driverSendSlice.reducer
